import axios from 'axios';
export default axios.create({
  //baseURL:'https://jsonplaceholder.typicode.com/',
  baseURL:'https://one.skynavieros.com:8080/skyone/',
  Headers: { 'Content-Type':'application/json'},
})
